import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { MonthInsight } from '../../model/month-insight.js';
import { summaryQueries } from './summary-queries.js';

export const useMonthInsightQuery = (isEnabled: boolean): UseQueryResult<MonthInsight> =>
  useQuery({ ...summaryQueries.insight(), enabled: isEnabled });
